<div class="flex-vertical gap-12">
  @if (formArray.length === 0) {
    <div class="file-uploader-container">
      <oui-file-uploader
        class="width-100-pc"
        type="multi"
        [accept]="acceptedFileType()"
        [control]="fileControl"
        [maxFileSize]="20"
        [hint]="fileUpdloaderHint()">
      </oui-file-uploader>
    </div>
  }
  @if (formArray.length > 0) {
    <div>
      @for (fileGroup of formArray.controls; track fileGroup.value; let index = $index) {
        @if (fileGroup.controls.displayBanner.value) {
          <oui-banner
            [title]="fileGroup.controls.bannerLabel.value ?? ''"
            declination="error"
            [showCloseButton]="false">
          </oui-banner>
        }
        <div class="document-card oui-elevation-04">
          <div class="flex-horizontal flex-center">
            <oui-file-item
              type="condensed"
              [file]="fileGroup.controls.file.value"
              (delete)="deleteFile(index)">
            </oui-file-item>
            <div class="flex-horizontal gap-10 flex-center min-height-55-px flex-wrap">
              @if (isCouple() && !isSignatureDocument()) {
                <oui-select
                  class="investisseur-input"
                  [control]="fileGroup.controls.relatedInvestisseur"
                  label="Attaché à"
                  [options]="investisseurOptions()">
                </oui-select>
              }
              <oui-autocomplete
                class="width-270"
                [control]="fileGroup.controls.documentType"
                label="Sélectionner un type"
                [options]="creationFilteredOptions()">
              </oui-autocomplete>
              @if (referenceDateDocumentTypes().has(fileGroup.controls.documentType.value)) {
                <oui-date-picker
                  label="Date du document"
                  [control]="fileGroup.controls.referenceDate"
                  [errors]="referenceDateErrors"
                  [min]="minSignatureDate()"
                  [max]="maxSignatureDate()"
                  [pivotYear]="currentDatePivotYear">
                </oui-date-picker>
              }
              @if (requiredSignatureDateTypes.includes(fileGroup.controls.documentType.value) && !isSignatureDocument()) {
                <oui-button-toggle
                  label="Signé ?"
                  [control]="fileGroup.controls.isSigned"
                  [options]="referenceDataService.yesNoOptions">
                </oui-button-toggle>
                @if (fileGroup.controls.isSigned.value && !fileGroup.controls.displayBanner.value) {
                  <oui-date-picker
                    class="signature-date-input"
                    [max]="maxSignatureDate()"
                    [min]="minSignatureDate()"
                    label="Date de signature"
                    [control]="fileGroup.controls.signatureDate"
                    [errors]="dateErrors"
                    [pivotYear]="currentDatePivotYear">
                  </oui-date-picker>
                }
              }
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>
